import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setToggleResults } from "../../../store/sop/actions";
const ToggleResults = ({ className }: { className?: string }) => {
  const selector = useSelector((state: any) => state.sop);
  const dispatch = useDispatch();
  return (
    <div
      className={`md:hidden justify-center bg-white  sticky flex w-full  py-2 pb-6  px-6 md:px-0  md:border-none ${className}`}
    >
      <button
        type="button"
        className={`
            ${
              !selector.toggleResults
                ? "bg-primary-100 text-primary-500 border-2 border-tootler-primary-900 hover:bg-primary-200"
                : "border border-tootler-primary-900  bg-white text-tootler-primary-900 hover:bg-gray-50"
            }
           w-full flex items-center justify-center rounded-full max-h-14  py-4 text-base font-medium  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500`}
        onClick={() => {
          dispatch(setToggleResults(false));
        }}
      >
        Edit Form
      </button>
    </div>
  );
};

export default ToggleResults;
